import { useEffect, useRef } from "react";
import { Html5Qrcode } from "html5-qrcode";

const isDev = process.env.NODE_ENV === "development";

// Extracts a claim code from a scanned value: either a full URL (.../claim/CODE) or a raw code.
function parseCode(text) {
  if (!text) return "";
  const t = text.trim();
  const m = t.match(/\/claim\/([A-Za-z0-9]+)/);
  if (m) return m[1].toUpperCase();
  return t.toUpperCase();
}

export function QrScanner({ onScan, onError }) {
  const ref = useRef(null);
  const onScanRef = useRef(onScan);
  const onErrorRef = useRef(onError);
  onScanRef.current = onScan;
  onErrorRef.current = onError;

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const id = "qr-reader-region";
    el.id = id;

    const scanner = new Html5Qrcode(id, { verbose: false });
    let started = false;
    let cancelled = false;

    const safeStop = () => {
      // html5-qrcode.stop() can throw synchronously if the scanner never started.
      try {
        const p = scanner.stop();
        if (p && typeof p.then === "function") {
          p.then(() => {
            try { scanner.clear(); } catch (e) { if (isDev) console.debug("qr clear (ignored):", e?.message); }
          }).catch(() => {});
        }
      } catch (e) {
        try { scanner.clear(); } catch (e2) { if (isDev) console.debug("qr clear (ignored):", e2?.message); }
      }
    };

    const onSuccess = (decoded) => {
      const code = parseCode(decoded);
      if (code) { cancelled = true; if (started) safeStop(); onScanRef.current && onScanRef.current(code); }
    };

    scanner
      .start({ facingMode: "environment" }, { fps: 10, qrbox: { width: 240, height: 240 } }, onSuccess, () => {})
      .then(() => { started = true; if (cancelled) safeStop(); })
      .catch((err) => { onErrorRef.current && onErrorRef.current(err); });

    return () => {
      cancelled = true;
      if (started) safeStop();
    };
  }, []);

  return <div ref={ref} className="mx-auto w-full max-w-xs overflow-hidden rounded-xl border border-border" data-testid="qr-scanner-region" />;
}
